module.exports = __webpack_public_path__ + "b59dda63940ad8319293d68438c7f2f9.pdf";